// import Swiper JS
import Swiper from "swiper";
// core version + navigation, pagination modules:
import SwiperCore, {
    Navigation,
    Pagination,
    Mousewheel,
    Parallax,
    Thumbs,
    Lazy,
} from "swiper/core";
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Mousewheel, Parallax, Thumbs, Lazy]);

// import Swiper styles
import "swiper/swiper-bundle.css";
import { URLASSOLUTO } from "./variables";

const swiper = $(document).ready(function () {
    var swiper1counter = false;
    if ($(".swiper-container.swiper1 .swiper-slide").length > 1) {
        swiper1counter = true;
    }
    var swiper1 = new Swiper(".swiper-container.swiper1", {
        navigation: {
            nextEl: ".swiper-arrow-next.swiper1",
            prevEl: ".swiper-arrow-prev.swiper1",
        },
        lazy: true,
        preloadImages: false,
        autoHeight: false, //enable auto height
        slidesPerView: 1,
        spaceBetween: 50,
        debugger: true,
        loop: false,
        observer: true,
        observeParents: true,
        breakpoints: {
            461: {
                slidesPerView: 1,
                spaceBetween: 40,
                watchSlidesProgress: true,
            },
            577: {
                slidesPerView: 1,
                spaceBetween: 40,
                watchSlidesProgress: true,
            },
            769: {
                slidesPerView: 2,
                spaceBetween: 40,
                watchSlidesProgress: true,
            },
            993: {
                slidesPerView: 3,
                spaceBetween: 30,
                watchSlidesProgress: true,
            },
            1201: {
                slidesPerView: 3,
                spaceBetween: 40,
                watchSlidesProgress: true,
            },
        },
    });

    var swiper2counter = false;
    if ($(".swiper-container.swiper2 .swiper-slide").length > 1) {
        swiper2counter = true;
    }
    var swiper2 = new Swiper(".swiper-container.swiper2", {
        navigation: {
            nextEl: ".swiper-arrow-next.swiper2",
            prevEl: ".swiper-arrow-prev.swiper2",
        },
        // Enable debugger
        debugger: true,
        watchOverflow: true,
        loop: swiper2counter,
    });

    var swiper3counter = false;
    if ($(".swiper-container.swiper3 .swiper-slide").length > 1) {
        swiper3counter = true;
    }
    var swiper3 = new Swiper(".swiper-container.swiper3", {
        navigation: {
            nextEl: ".swiper-arrow-next.swiper3",
            prevEl: ".swiper-arrow-prev.swiper3",
        },
        // Enable debugger
        debugger: true,
        slidesPerView: 1,
        watchOverflow: true,
        loop: swiper3counter,
        breakpoints: {
            577: {
                slidesPerView: 2,
            },
        },
    });

    /*
      xs: 0,
  sm: 576px,
  md: 768px,
  lg: 992px,
  xl: 1200px,
  xxl: 1400px,
  xxxl: 1600px,
  uhd: 2056px,
  uuhd: 2440px
  */

    $(".swipercat").each(function (index) {
        var item = $(this).data("item");

        var nrslideuuhd = $(this).data("nrslideuuhd");
        if (typeof $(this).data("nrslideuuhd") === "undefined") {
            nrslideuuhd = 1;
        }

        var nrslideuhd = $(this).data("nrslideuhd");
        if (typeof $(this).data("nrslideuhd") === "undefined") {
            nrslideuhd = 1;
        }

        var nrslidexxl = $(this).data("nrslidexxl");
        if (typeof $(this).data("nrslidexxl") === "undefined") {
            nrslidexxl = 1;
        }

        var nrslidexl = $(this).data("nrslidexl");
        if (typeof $(this).data("nrslidexl") === "undefined") {
            nrslidexl = 1;
        }

        var nrslidelg = $(this).data("nrslidelg");
        if (typeof $(this).data("nrslidelg") === "undefined") {
            nrslidelg = 1;
        }

        var nrslidemd = $(this).data("nrslidemd");
        if (typeof $(this).data("nrslidemd") === "undefined") {
            nrslidemd = 1;
        }

        var nrslidesm = $(this).data("nrslidesm");
        if (typeof $(this).data("nrslidesm") === "undefined") {
            nrslidesm = 1;
        }

        var nrslideseparator = $(this).data("nrslideseparator");

        console.log(
            $(".swiper-container.swipercat" + item + " .swiper-slide").length +
                " --"
        );
        new Swiper(".swiper-container.swipercat" + item, {
            watchOverflow: true,
            slidesPerView: 1,
            // Disable preloading of all images
            preloadImages: false,
            // Enable lazy loading
            lazy: true,
            spaceBetween: nrslideseparator,
            loop:
                $(".swiper-container.swipercat" + item + " .swiper-slide")
                    .length > 1,
            breakpoints: {
                577: {
                    slidesPerView: nrslidesm,
                    loop:
                        $(
                            ".swiper-container.swipercat" +
                                item +
                                " .swiper-slide"
                        ).length > nrslidesm,
                },
                769: {
                    slidesPerView: nrslidemd,
                    loop:
                        $(
                            ".swiper-container.swipercat" +
                                item +
                                " .swiper-slide"
                        ).length > nrslidemd,
                },
                993: {
                    slidesPerView: nrslidelg,
                    loop:
                        $(
                            ".swiper-container.swipercat" +
                                item +
                                " .swiper-slide"
                        ).length > nrslidelg,
                },
                1201: {
                    slidesPerView: nrslidexl,
                    loop:
                        $(
                            ".swiper-container.swipercat" +
                                item +
                                " .swiper-slide"
                        ).length > nrslidexl,
                },
                1401: {
                    slidesPerView: nrslidexxl,
                    loop:
                        $(
                            ".swiper-container.swipercat" +
                                item +
                                " .swiper-slide"
                        ).length > nrslidexxl,
                },
                2057: {
                    slidesPerView: nrslideuhd,
                    loop:
                        $(
                            ".swiper-container.swipercat" +
                                item +
                                " .swiper-slide"
                        ).length > nrslideuhd,
                },
                2441: {
                    slidesPerView: nrslideuuhd,
                    loop:
                        $(
                            ".swiper-container.swipercat" +
                                item +
                                " .swiper-slide"
                        ).length > nrslideuuhd,
                },
            },
            navigation: {
                nextEl: ".swiper-arrow-next.swiper" + item,
                prevEl: ".swiper-arrow-prev.swiper" + item,
            },
            on: {
                afterInit: function () {
                    $(".sameheight").boxheight();
                    if (
                        $(".swiper-arrow-next.swiper" + item).hasClass(
                            "swiper-button-disabled"
                        )
                    ) {
                        $(
                            ".swiper-container.swipercat" +
                                item +
                                " .swiper-wrapper"
                        ).addClass("justify-content-center");
                    } else {
                        $(
                            ".swiper-container.swipercat" +
                                item +
                                " .swiper-wrapper"
                        ).removeClass("justify-content-center");
                    }
                },
                resize: function () {
                    $(".sameheight").boxheight();
                    if (
                        $(".swiper-arrow-next.swiper" + item).hasClass(
                            "swiper-button-disabled"
                        )
                    ) {
                        $(
                            ".swiper-container.swipercat" +
                                item +
                                " .swiper-wrapper"
                        ).addClass("justify-content-center");
                    } else {
                        $(
                            ".swiper-container.swipercat" +
                                item +
                                " .swiper-wrapper"
                        ).removeClass("justify-content-center");
                    }
                },
            },
            // Enable debugger
            debugger: true,
        });
    });

    var swiperv = new Swiper(".swiper-container.swiperv", {
        direction: "vertical",
        slidesPerView: 1,
        mousewheel: true,
        speed: 1000,
        parallax: true,
        on: {
            slideChange: function () {
                let index_currentSlide = this.realIndex,
                    currentSlide = this.slides[index_currentSlide];

                $(".swiper-container.swiperv")
                    .find(".headerCategory")
                    .removeClass("isvisible");
                $(".swiper-container.swiperv")
                    .find(".headerCategoryImage")
                    .removeClass("isvisible");
                $(currentSlide).find(".headerCategory").addClass("isvisible");
                $(currentSlide)
                    .find(".headerCategoryImage")
                    .addClass("isvisible");
            },
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        // Enable debugger
        debugger: true,
    });

    var galleryThumbs = new Swiper(".gallery-thumbs", {
        //centeredSlides: true,
        centeredSlidesBounds: true,
        slidesPerView: 3,
        spaceBetween: 10,
        allowTouchMove: false,
        watchOverflow: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        direction: "horizontal",
        centeredSlides: false,
        breakpoints: {
            576: {
                direction: "vertical",
            },
        },
    });

    var galleryMain = new Swiper(".gallery-main", {
        watchOverflow: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        allowTouchMove: false,
        preventInteractionOnTransition: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        thumbs: {
            swiper: galleryThumbs,
        },
    });

    if (galleryMain.slides.length > galleryThumbs.passedParams.slidesPerView) {
        galleryMain.on("slideChangeTransitionStart", function () {
            galleryThumbs.slideTo(galleryMain.activeIndex);
        });

        galleryThumbs.on("transitionStart", function () {
            galleryMain.slideTo(galleryThumbs.activeIndex);
        });
    }
});

export { swiper as default };
